import axiosInstance from './api';
import {
  normalizePartnerPlansResponse,
  pickPartnerCheckoutUrl,
} from '../utils/partnerSubscriptionPlans';
import {
  normalizePartnerPlanPaymentsResponse,
  PARTNER_PLAN_PAYMENTS_PAGE_SIZE,
} from '../utils/partnerSubscriptionPayments';

const getErrorMessage = (error, fallback) => error?.message || error?.error?.message || fallback;

/** GET /admin/plans — partner portal fee for authenticated partner. */
export const listPartnerPlans = async () => {
  try {
    const response = await axiosInstance.get('/admin/plans');
    return {
      success: true,
      data: normalizePartnerPlansResponse(response.data),
      message: response.data?.message || 'Partner subscription plans fetched successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Failed to fetch partner subscription plans'),
      error,
    };
  }
};

/**
 * GET /admin/plans/payments — successful subscription payments for authenticated partner org.
 * Query: page, limit
 */
export const listPartnerPlanPayments = async ({
  page = 1,
  limit = PARTNER_PLAN_PAYMENTS_PAGE_SIZE,
} = {}) => {
  try {
    const params = {
      page: Math.max(1, Number(page) || 1),
      limit: Math.max(1, Number(limit) || PARTNER_PLAN_PAYMENTS_PAGE_SIZE),
    };
    const response = await axiosInstance.get('/admin/plans/payments', { params });
    return {
      success: true,
      data: normalizePartnerPlanPaymentsResponse(response.data, params),
      message: response.data?.message || 'Partner subscription payments fetched successfully',
    };
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Failed to fetch partner subscription payments'),
      error,
    };
  }
};

/**
 * POST /admin/plans/checkout
 * Body: { successUrl, cancelUrl, failureUrl } — fee comes from partner pricing row.
 */
export const createPartnerPlanCheckout = async ({ successUrl, cancelUrl, failureUrl } = {}) => {
  try {
    const response = await axiosInstance.post('/admin/plans/checkout', {
      successUrl,
      cancelUrl,
      failureUrl,
    });

    const data = response.data?.data ?? response.data;
    const checkoutUrl = pickPartnerCheckoutUrl(response.data);

    return {
      success: true,
      data,
      checkoutUrl,
      message: response.data?.message || 'Checkout session created',
    };
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Failed to start plan checkout'),
      error,
    };
  }
};
